require('./cardPINChangeSuccess.override.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

const CardPINChangeSuccess = props => {
    const { immCard } = props;
    const title = formatText('cardPinChangeSuccess-cardPinChangeSuccess_title');
    const linkToDetails = `/myprofile/cards/${immCard.get('cardId')}/details`;
    const goBackButton = {
        label: <FormattedText value="cardPinChangeSuccess-cardPinChangeSuccess_goBackButton" format="uppercase" />,
        url: linkToDetails
    };

    return (
        <article className="card-pin-change-success">
            <WizardSuccess
                successMessage={title}
                mainButton={goBackButton}
            >
                <section className="row no-gutter">
                    <div className="col-xs-4">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-8">
                        <FormattedText value="cardPinChangeSuccess-cardPinChangeSuccess_message"/>
                    </div>
                </section>
            </WizardSuccess>
        </article>
    );
};

CardPINChangeSuccess.propTypes = {
    immCard: PropTypes.object
}

module.exports = CardPINChangeSuccess;